var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVerification = function SvgVerification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m30 2.5 20.542 4.565a2.5 2.5 0 0 1 1.958 2.44v24.967a15 15 0 0 1-6.68 12.481L30 57.5 14.18 46.953a15 15 0 0 1-6.68-12.48V9.504a2.5 2.5 0 0 1 1.958-2.44L30 2.5Zm0 5.122-17.5 3.889v22.961a10 10 0 0 0 4.453 8.32L30 51.492l13.047-8.698a10 10 0 0 0 4.453-8.32V11.51L30 7.622Zm11.131 12.933 3.535 3.535L28.756 40 18.15 29.393l3.536-3.535 7.069 7.07L41.13 20.554Z",
    fill: "#1D1737"
  })));
};
export default SvgVerification;